module.exports = __webpack_public_path__ + "img/history-map-placeholder.5c7754d8.svg";